module.exports = __webpack_public_path__ + "media/images/Heart_Pink_120-d0b3cd6e.png";